module.exports = __webpack_public_path__ + "img/food_popcorn.1c2d4540.png";